module.exports = __webpack_public_path__ + "img/1559696270.fc967b8d.jpg";